import { useSelector } from 'react-redux'
import { OrderInterface } from '../../../../../common/types/interfaces'
import { Item } from '../item/Item'
import classes from './List.module.sass'
import { selectConnected } from '../../../../../store/slices/wsSlice'

type Props = {
  startEdit: (el: OrderInterface) => void
  showDetails: (el: OrderInterface) => void
  list: OrderInterface[] | []
  loading: boolean
}

export const List = ({ startEdit, list, showDetails, loading }: Props) => {
  const isConnected = useSelector(selectConnected)

  return (
    <div className={classes.container}>
      {!list || !Array.isArray(list) || (!list.length && !loading) ? (
        <div className={classes.Message}>Нет заказов</div>
      ) : (
        list.map((el: OrderInterface) => (
          <Item
            showDetails={showDetails}
            el={el}
            startEdit={startEdit}
            key={el.id}
            isConnected={isConnected}
          />
        ))
      )}
    </div>
  )
}
